import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'common/components/Button';
import AvailabilityForm from './AvailabilityForm';
import { makeAvailabilityStyles, makeDialogTitleStyles } from 'styles/components/availability';
import { IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

type Props = {
    code: string;
};

const AvailabilityDialog: React.FC<Props> = ({ code }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const { openButton } = makeAvailabilityStyles();
    const dialogTitleClasses = makeDialogTitleStyles();

    return (
        <>
            <Button
                colorTheme="outlinedPrimary"
                className={openButton}
                disableElevation
                onClick={handleOpen}
                size="large"
                variant="outlined"
            >
                Powiadom mnie
                <br />o dostępności
            </Button>
            <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
                <DialogTitle classes={dialogTitleClasses} disableTypography>
                    <Typography component="h4" variant="h6">
                        Powiadomienie o dostępności
                    </Typography>
                    <IconButton aria-label="close" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Prosimy, podaj swój adres e-mail.
                        <br />
                        Powiadomimy Cię, kiedy ten produkt będzie w sprzedaży.
                    </DialogContentText>
                    <AvailabilityForm code={code} handleClose={handleClose} />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default AvailabilityDialog;
